import { createFileRoute } from '@tanstack/react-router'

import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'
import { SidenavPageLayoutSkeleton } from '#lib/skeletons/sidenav-page-layout-skeleton'

export const Route = createFileRoute('/_dashboard/_personal')({
  staticData: { title: '' },
  pendingComponent: SidenavPageLayoutSkeleton,
  component: lazyLoadedComponent(
    () => import('#app/pages/personal/personal-account-layout'),
    'PersonalAccountLayout',
  ),
})
